import type { Ops } from 'types/Ops'
import 'types/Ops'
type State = {
  ops: Ops
}
export const getOps = (state: State): Record<string, any> => state.ops || {}